export default __webpack_public_path__ + "static/media/remove.e53073c9.svg";